import { cacheConfig, http } from '../helpers/axiosHelper';

export default class LanguageService {
   async getLanguages() {
      return await http.get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/language', { ...cacheConfig }).then((response) => {
         return response.data;
      });
   }
}
